/**
 * Credit adjustment modal wiring.
 */
import {
  openCheckoutModal,
  openCreditAdjustmentModal,
  closeCreditAdjustmentModal,
} from '../../modules/ui';
import type { ModalHandlerDeps } from './types';

export function setupCreditAdjustmentHandlers(deps: ModalHandlerDeps): void {
  const { els } = deps;

  if (els.superadminAdjustCreditsBtn) {
    els.superadminAdjustCreditsBtn.addEventListener('click', () => {
      openCreditAdjustmentModal();
    });
  }

  if (els.closeCreditAdjustmentModal) {
    els.closeCreditAdjustmentModal.addEventListener('click', () => {
      closeCreditAdjustmentModal();
    });
  }

  if (els.creditAdjustmentCancel) {
    els.creditAdjustmentCancel.addEventListener('click', () => {
      closeCreditAdjustmentModal();
    });
  }

  if (els.creditAdjustmentModalBackdrop) {
    els.creditAdjustmentModalBackdrop.addEventListener('click', () => {
      closeCreditAdjustmentModal();
    });
  }

  if (els.creditAdjustmentForm) {
    els.creditAdjustmentForm.addEventListener('submit', deps.handleCreditAdjustmentSubmit);
  }

  if (els.optionsBuyCredits) {
    els.optionsBuyCredits.addEventListener('click', () => {
      openCheckoutModal();
    });
  }

  if (els.creditAdjustmentNote && els.creditNoteCharCount) {
    els.creditAdjustmentNote.addEventListener('input', () => {
      if (els.creditNoteCharCount) {
        els.creditNoteCharCount.textContent = (
          els.creditAdjustmentNote as HTMLTextAreaElement
        ).value.length.toString();
      }
    });
  }
}
